<template>
    <template v-if="true">
        <nav class="flex justify-start items-center">
            <designProgressStepSegment
                v-for="(item, idx) in items"
                v-bind="$attrs"
                @click="$emit('click-step', item)"
                :key="idx"
                :scale-x="scaleX"
                :scale-y="scaleY"
                :style="{ marginLeft: idx === 0 ? '0px' : `${overlap}px` }"
                :variant="segmentVariant(idx, items.length)"
                :step="item.step"
                :title="item.title"
                :active-status="getActiveStatus(item.step, currentStep)"
            />
        </nav>

        <!-- 전역 재사용 필터: 한 번만 정의 -->
        <svg
            width="0"
            height="0"
            class="absolute pointer-events-none select-none"
            aria-hidden="true"
        >
            <defs>
                <filter
                    id="stepDropShadow"
                    x="0"
                    y="0"
                    width="220"
                    height="110"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="1"
                        operator="dilate"
                        in="SourceAlpha"
                        result="effect1_dropShadow"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    </template>
</template>

<script>
import designProgressStepSegment from './design-progress-step-segiment.vue';

export default {
    components: {
        designProgressStepSegment,
    },
    emits : ['click-step'],
    props: {
        items: {
            type: Array,
            default: function () {
                return [];
            },
        },
        currentStep: { type: String, default: '_BASIC_' },
        scaleX: { type: Number, default: 1 },
        scaleY: { type: Number, default: 1 },
        // 양수: 더 벌어짐, 음수: 겹치게
        overlap: { type: Number, default: 0 },
    },
    methods: {
        segmentVariant(idx, len) {
            if (idx === 0) return 'FIRST';
            if (idx === len - 1) return 'LAST';
            return 'MIDDLE';
        },
        getActiveStatus(step, current) {
            const currentIdx = this.items.findIndex(s => s.stepId == current) || 0;
            if( currentIdx == -1 ){
                return;
            }
            const currentStep = this.items[currentIdx].step;
            if (step == currentStep) return 'ONGOING';
            if (step > currentStep) return 'NEXT';
            if (step < currentStep) return 'COMPLETE';
        },
    },
};
</script>
